export default "__VITE_ASSET__d61bbf2b__"